<div class="dialogue-content">
  <div class="mat-dialogue-header">
    <h4 class="mat-dialog-title previewHeading" id="modal-basic-title" *ngIf="isProjectDescriptionBasedAnswer">Chat GPT
      Answer</h4>
    <h4 class="mat-dialog-title previewHeading" id="modal-basic-title" *ngIf="!isProjectDescriptionBasedAnswer">AI
      Generated Answer</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="cancel()"></button>
  </div>
  <mat-dialog-content class>
    <p class="mb-2" *ngIf="isProjectDescriptionBasedAnswer">
      Project Description and answer based on provided description. Would you like to add this answer?
    </p>
    <p class="mb-2" *ngIf="!isProjectDescriptionBasedAnswer">
      Below are your provided answer and the AI-generated answer. Would you like to replace your answer with the
      generated one?
    </p>

    <div class="card p-3 mb-2">
      <h6 class="fw-bold text-primary" *ngIf="isProjectDescriptionBasedAnswer">
        Question:
      </h6>
      <h6 class="fw-bold text-primary" *ngIf="!isProjectDescriptionBasedAnswer">
        Your Answer:
      </h6>

      <p class="border rounded p-2 bg-light m-0" [innerHTML]="userAnswer"></p>
    </div>

    <div class="card p-3">
      <h6 class="fw-bold text-success" *ngIf="!isProjectDescriptionBasedAnswer">AI-Generated Answer:</h6>
      <h6 class="fw-bold text-success" *ngIf="isProjectDescriptionBasedAnswer">Chat GPT Answer:</h6>
      <p class="border rounded p-2 bg-light" [innerHTML]="generatedAnswer"></p>
    </div>

    <div class="card p-3 mb-2"  *ngIf="!isProjectDescriptionBasedAnswer">
      <h6 class="fw-bold text-success">Regenerate with different Prompt</h6>
      <input type="text" class="form-control txt-bold"  [(ngModel)]="prompt" />
    </div>

  </mat-dialog-content>
  <div mat-dialog-actions class="dialog-actions dialogue-footer text-center mb-3">
    <button class="btn btn-primary" (click)="replace()">Replace</button>
    <button class="btn btn-primary"  *ngIf="!isProjectDescriptionBasedAnswer" (click)="reGenerate()">Generate Again</button>
    <button class="btn btn-secondary" (click)="cancel()">Cancel</button>
  </div>
</div>